export const ATTENDANCE_STATUSES = {
  ASSIGNED: 'Assigned',
  ON_TIME: 'On Time',
  LATE: 'Late',
  LATE_ALLOWED_TO_WORK: 'Late Allowed to Work',
  LATE_SENT_HOME: 'Late Sent Home',
  ABSENT: 'Absent',
  CANCELLED: 'Cancelled',
  VTO: 'VTO',
  ANNUAL_LEAVE: 'Annual Leave',
  EMERGENCY_LEAVE: 'Emergency Leave',
  MEDICAL_LEAVE: 'Medical Leave',
  UNPAID_LEAVE: 'Urgent / Unpaid Leave',
  CHILD_CARE_LEAVE: 'Child Care Leave',
  HOSPITALIZATION_LEAVE: 'Hospitalization Leave',
};

export const ATTENDANCE_STATUSES_NAME = {
  1: 'Assigned',
  2: 'On Time',
  3: 'Late',
  4: 'Late Allowed to Work',
  5: 'Late Sent Home',
  6: 'Absent',
  7: 'Cancelled',
  8: 'VTO',
};

export const REQUEST_STATUSES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
};

export const APP_SERVICE = {
  MENU: 'api/user-group/menu-list',
  SELECTED_WORKSHOP: 'api/selected/workshop',
  VENDOR_OPTIONS: 'api/vendor/options',
  WAREHOUSE_OPTIONS: 'api/warehouse/options',
  USER_OPTIONS: 'api/user/options',
};

export const CLAIM_STATUSES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
};

export const LEAVE_STATUSES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
};
